import { createReducer } from 'utils/redux'

const defaultState = {
  skipCampaigns: false,
  skipWidgetTargeting: false,
  forceShowWidget: false,
  isOnline: false,
  hasExitIntent: false
}

const setShouldSkipCampaignsHandler = ({ action, draft }) => {
  draft.skipCampaigns = action.payload
}

const setShouldSkipWidgetTargetingHandler = ({ action, draft }) => {
  draft.skipWidgetTargeting = action.payload
}

const setShouldForceShowWidgetHandler = ({ action, draft }) => {
  draft.forceShowWidget = action.payload
}

const updateOnlineStatusHandler = ({ action, draft }) => {
  draft.isOnline = action.payload
}

const setHasExitIntentHandler = ({ draft }) => {
  draft.hasExitIntent = true
}

const actions = {
  SET_HAS_EXIT_INTENT: setHasExitIntentHandler,
  UPDATE_ONLINE_STATUS: updateOnlineStatusHandler,
  SET_SHOULD_SKIP_CAMPAIGNS: setShouldSkipCampaignsHandler,
  SET_SHOULD_FORCE_SHOW_WIDGET : setShouldForceShowWidgetHandler,
  SET_SHOULD_SKIP_WIDGET_TARGETING: setShouldSkipWidgetTargetingHandler
}

const sessionReducer = createReducer(
  defaultState,
  actions
)

export default sessionReducer
